import Permitted from './Permitted';

export default Permitted;
